import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import {
  HEADER,
  NEW_BUSINESS,
  UPDATE_NEW_BUSINESS,
  SAVE_NEW_BUSINESS_FILE,
  VIEW_NEW_BUSINESS_FILE,
  VIEW_NEW_BUSINESS_FILE_SUMMARY,
  URL_SERVER,
  SAVE_NEW_BUSINESS,
} from '../../utils/constants';
import Axios from 'axios';
import ReactHover from 'react-hover';
import ModalNewBusiness from '../buttons/modalNewBusiness';
import ViewWithTimpeStamp from '../../components/buttons/viewWithTimeStamp';
import Save from '../../components/buttons/save';
import ViewSummary from '../../components/buttons/viewSummary';
import DeleteNewBusiness from '../buttons/deleteNewBusiness';
import NoteNewBusiness from '../buttons/noteNewBusiness';
import ViewVisitsGraphNewBusiness from '../../components/buttons/viewVisitsGraphNewBusiness';

let Loader = require('react-loader');


class NewBusinessTable extends Component {

  constructor(props) {
    super(props);
    this.callback = this.callback.bind(this);
    this.callbackDelete = this.callbackDelete.bind(this);
    this.callbackFile = this.callbackFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      data: [],
      key: null,
      keyFile: null,
      loaded: false,
      save: false,
    };
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  callback(dataFromchild) {
    this.setState({ key: dataFromchild });
  }

  callbackNote(dataFromchild) {
    this.setState({ key: dataFromchild });
  }

  callbackDelete(dataFromchild) {
    this.setState({ key: dataFromchild });
  }

  callbackFile(dataFromchild) {
    this.setState({ keyFile: dataFromchild });
  }

  render() {

    let classUser = this.props.authorization ? 'corrAct-view' : 'quality-edit-unauthorized';

    const headerStyle = {
      background: HEADER.BACKCOLOR,
      color: HEADER.COLOR,
      fontSize: HEADER.FONTSIZE,
      textAlign: 'left'
    };

    const optionsCursorTrueWithMargin = {
      followCursor: true,
      shiftX: 20,
      shiftY: 0
    }

    const header = [{
      Header: 'Tipo de Operación',
      accessor: 'operationType',
      headerStyle: headerStyle,
    },
      {
        Header: 'Facilitador',
        accessor: 'fasilitator',
        headerStyle: headerStyle,
      },
      {
        Header: 'Estado',
        accessor: 'estate',
        headerStyle: headerStyle,
      },
      {
        Header: 'Muinicipio',
        accessor: 'municipality',
        headerStyle: headerStyle,
      },
      {
        Header: 'Etapa',
        accessor: 'phase',
        headerStyle: headerStyle,
        Cell: row => {
          let cell;
          switch (row.value) {
            case 'A':
              cell = <ReactHover options={optionsCursorTrueWithMargin}>
                <ReactHover.Trigger type='trigger'>
                  <div>{row.value}</div>
                </ReactHover.Trigger>
                <ReactHover.Hover type='hover'>
                  <div className='hover-text'> Nombrar/asignar facilitador</div>
                </ReactHover.Hover>
              </ReactHover>;
              break;
            case 'B':
              cell = <ReactHover options={optionsCursorTrueWithMargin}>
                <ReactHover.Trigger type='trigger'>
                  <div>{row.value}</div>
                </ReactHover.Trigger>
                <ReactHover.Hover type='hover'>
                  <div className='hover-text'> Cita Obtenida</div>
                </ReactHover.Hover>
              </ReactHover>;
              break;
            case 'C':
              cell = <ReactHover options={optionsCursorTrueWithMargin}>
                <ReactHover.Trigger type='trigger'>
                  <div>{row.value}</div>
                </ReactHover.Trigger>
                <ReactHover.Hover type='hover'>
                  <div className='hover-text'> Presentación de nuestros servicios</div>
                </ReactHover.Hover>
              </ReactHover>;
              break;
            case 'D':
              cell = <ReactHover options={optionsCursorTrueWithMargin}>
                <ReactHover.Trigger type='trigger'>
                  <div>{row.value}</div>
                </ReactHover.Trigger>
                <ReactHover.Hover type='hover'>
                  <div className='hover-text'> Cuestionarios predial y agua</div>
                </ReactHover.Hover>
              </ReactHover>;
              break;
            case 'E':
              cell = <ReactHover options={optionsCursorTrueWithMargin}>
                <ReactHover.Trigger type='trigger'>
                  <div>{row.value}</div>
                </ReactHover.Trigger>
                <ReactHover.Hover type='hover'>
                  <div className='hover-text'> Visita de familiarización</div>
                </ReactHover.Hover>
              </ReactHover>;
              break;
            case 'F':
              cell = <ReactHover options={optionsCursorTrueWithMargin}>
                <ReactHover.Trigger type='trigger'>
                  <div>{row.value}</div>
                </ReactHover.Trigger>
                <ReactHover.Hover type='hover'>
                  <div className='hover-text'> Análisis potencial</div>
                </ReactHover.Hover>
              </ReactHover>;
              break;
            case 'G':
              cell = <ReactHover options={optionsCursorTrueWithMargin}>
                <ReactHover.Trigger type='trigger'>
                  <div>{row.value}</div>
                </ReactHover.Trigger>
                <ReactHover.Hover type='hover'>
                  <div className='hover-text'> Entrega formal del contrato</div>
                </ReactHover.Hover>
              </ReactHover>;
              break;
            case 'H':
              cell = <ReactHover options={optionsCursorTrueWithMargin}>
                <ReactHover.Trigger type='trigger'>
                  <div>{row.value}</div>
                </ReactHover.Trigger>
                <ReactHover.Hover type='hover'>
                  <div className='hover-text'> Cierre de Contrato</div>
                </ReactHover.Hover>
              </ReactHover>;
              break;
            default :
              cell = '';
              break;
          }
          return (cell);
        }
      },
      {
        Header: 'Fecha de inicio de la etapa',
        accessor: 'date',
        headerStyle: headerStyle,
      },
      {
        Header: 'Indicadores',
        accessor: 'appointments',
        headerStyle: headerStyle,
        Cell: row => (this.lastVisitDay = '',row.value.appointments.map((arr) => {
          this.lastVisitDay = arr.realDate;
        }), <ViewVisitsGraphNewBusiness id={row.value.id} municipality={row.value.municipality} callbackFromParent={this.callback} lastVisitDay={this.lastVisitDay}
                                                  authorization={this.props.authorization} operationType={row.value.operationType} appointments={row.value.appointments}/>)
      },
      {
        Header: 'Notas',
        accessor: 'notes',
        headerStyle: headerStyle,
        Cell: row => (<div className='d-flex justify-content-around'>
          <NoteNewBusiness authorization={this.props.authorization} id={row.value.id}
                           notes={row.value.notes} callbackFromParent={this.callback}/>
          <ModalNewBusiness authorization={this.props.authorization}
                            dateModal={this.props.dateModal} title={'Actualizar negocio.'}
                            callbackFromParent={this.callback} className={classUser}
                            url={UPDATE_NEW_BUSINESS} id={row.value.id} isUpdate={true}/>
          <DeleteNewBusiness authorization={this.props.authorization} id={row.value.id}
                             callbackFromParent={this.callbackDelete}
                             title={`${row.value.fasilitator} de ${row.value.operationType} en ${row.value.municipality}`}/>
        </div>)

      }
    ];

    const data = [{
      operationType: '',
      fasilitator: '',
      estate: '',
      municipality: '',
      phase: '',
      date: '',
    }];

    let dataTable = (this.state.data !== null) ? this.state.data : data;

    return (<div className='container-fluid back-color-grey'>
      <div className='d-flex justify-content-end'>
        <ViewSummary url={VIEW_NEW_BUSINESS_FILE_SUMMARY + this.props.year + '/' + this.props.month}
                     dateModal={this.props.dateModal} key={this.state.keyFile}/>
        <ViewWithTimpeStamp
          url={VIEW_NEW_BUSINESS_FILE + this.props.year + '/' + this.props.month}/>
        <Save url={SAVE_NEW_BUSINESS_FILE + this.props.year + '/' + this.props.month}
              authorization={this.props.authorization} callback={this.callbackFile}/>
        <ModalNewBusiness authorization={this.props.authorization} dateModal={this.props.dateModal}
                          title={'Crear nuevo negocio'}
                          callbackFromParent={this.callback} isUpdate={false}
                          className={'quality-edit'} url={SAVE_NEW_BUSINESS}/>
      </div>
      <div className='container pl-md-5 pr-md-5 pt-0 pb-5 pl-0 pr-0'>
        {/*<div className='container-fluid table-title'>
          TABLE TITLE
          </div>*/}
        <div className='borderTable' key={this.state.key}>
          <ReactTable
            className={'-striped'}
            columns={header}
            data={dataTable}
            showPageJump={true}
            noDataText="¡No hay negocios que mostrar!"
            showPageSizeOptions={true}
            pageSizeOptions={[5, 10, 15, 20, 25, 30, 35, 40]}
            defaultPageSize={5}
            showPagination={true}
            previousText={'Anterior'}
            pageText={'Página'}
            ofText={'de'}
            rowsText={'registros'}
            nextText={'Siguiente'}
            sortable={false}
            pages={this.state.pages} // should default to -1 (which means we don't know how many pages we have)
            manual // informs React Table that you'll be handling sorting and pagination server-side
            onFetchData={(state) => {
              // show the loading overlay
              this.setState({ loaded: false });
              // fetch your data
              Axios.get(URL_SERVER + NEW_BUSINESS + this.props.year + '/' + this.props.month + '?page=' + state.page + '&size=' + state.pageSize, {
                method: 'get',
                headers: { 'Authorization': sessionStorage.getItem('token') },
                page: state.page,
                pageSize: state.pageSize,
                sorted: state.sorted,
                filtered: state.filtered
              })
                .then((res) => {
                  // Update react-table

                  let data = res.data.data.map(arr => {
                    let reg = {
                      fasilitator: arr.fasilitator,
                      municipality: arr.municipality,
                      operationType: arr.operationType,
                      phase: arr.phase,
                      estate: arr.estate,
                      date: arr.date,
                      appointments: {
                        municipality: arr.municipality,
                        operationType: arr.operationType,
                        id: arr.id,
                        appointments: arr.appointments,
                      },
                      notes: {
                        id: arr.id,
                        fasilitator: arr.fasilitator,
                        municipality: arr.municipality,
                        operationType: arr.operationType,
                        notes: arr.notes
                      }
                    };
                    return reg;
                  });

                  this.setState({
                    data: data,
                    pages: res.data.totalPages,
                    loaded: true,
                  });
                });
            }}
          />
        </div>
        <Loader loaded={this.state.loaded}/>
      </div>
    </div>);

  }
}

export default NewBusinessTable;



// WEBPACK FOOTER //
// ./src/components/tables/newBusiness.js